import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ContactModal from "./ContactModal";
import { openContactModal } from "../../store/modalSlice";

const ContactFormMobile = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openContactModal()); 
  }, [dispatch]);

  return <ContactModal />;
};

export default ContactFormMobile;
